







import Vue from 'vue';
import { Configuration, ArenaSignTemplateAfterSignSettingModel, RouteRegEx } from '@/types';
import ArenaSignAfterSignMappingsManagement from '@/components/configuration/arenaSign/ArenaSignAfterSignMappingsManagement.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { MTablehelper, RouteHelpers } from '@/mixins';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';

export default Vue.extend({
  name: 'ScriveAfterSignMappingsManagement',
  mixins: [MTablehelper, RouteHelpers],
  data() {
    return {
      isLoading: true,
      fields: [
        {
          sourceDocumentTypeDescription: {
            label: 'Source Document Type',
            sortable: true
          }
        },
        {
          templateName: {
            label: 'Template Name',
            sortable: true
          }
        },
        {
          templateType: {
            label: 'Type',
            sortable: true
          }
        },
        {
          targetCabinetDescription: {
            label: 'Target Cabinet',
            sortable: true
          }
        },
        {
          targetDocumentTypeDescription: {
            label: 'Target Document Type',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      data: [] as ArenaSignTemplateAfterSignSettingModel[]
    };
  },
  methods: {
    async getData(this: any) {
      try {
        this.data = await ScriveConfigurationService.getTemplatesAfterSignConfigurationAsync();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToId(this: any, id: number) {
      this.$router.push({ name: Configuration.Scrive.AfterSignMapping.Edit.name, params: { id } });
    },
    resetViewState(this: any) {
      if (!this.canKeepState(RouteRegEx.ScriveEditTemplateAfterSignMappings)) {
        this.resetMTableState();
      }
    }
  },
  components: {
    LoadingSpinner,
    ArenaSignAfterSignMappingsManagement
  },
  async mounted() {
    this.resetViewState();
    await this.getData();
  }
});
